<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>作品列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 搜索筛选 -->
        <el-form :inline="true" style="margin-top: 20px;">
            <el-form-item>
                <el-input size="small" v-model="userName" placeholder="请输入用户昵称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input size="small" v-model="keyword" placeholder="请输入发布主题"></el-input>
            </el-form-item>
            <el-form-item label="审核类型：">
                <el-select size="small" v-model="status" placeholder="请选择审核类型">
                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="发布类型：">
                <el-select size="small" v-model="type" placeholder="请选择发布类型">
                    <el-option v-for="item in options1" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
            </el-form-item>
        </el-form>

        <!-- 列表 -->
        <el-table size="small" :data="workData" element-loading-text="拼命加载中" style="width: 100%;" v-horizontal-scroll
            border>
            <el-table-column align="center" sortable type="index" label="序号"></el-table-column>
            <el-table-column align="center" sortable prop="userName" label="用户昵称" width="120px"></el-table-column>
            <el-table-column align="center" sortable prop="categoryName" label="分类名" width="120px"></el-table-column>
            <el-table-column align="center" sortable prop="title" label="发布主题" width="120px"></el-table-column>
            <el-table-column align="center" sortable prop="content" label="发布内容" width="180px"></el-table-column>
            <el-table-column align="center" sortable prop="type" :formatter="Type" label="类型"
                width="120px"></el-table-column>
            <el-table-column align="center" sortable prop="state" :formatter="zhuangTai" label="状态"
                width="120px"></el-table-column>
            <el-table-column align="center" sortable prop="sort" label="是否置顶" width="120px">
                <template slot-scope="scope">
                    <div v-if="scope.row.sort == 0">已置顶</div>
                    <div v-if="scope.row.sort == 1000">未置顶</div>
                </template>
            </el-table-column>
            <el-table-column align="center" sortable prop="backRemark" label="驳回原因" width="140px"></el-table-column>
            <el-table-column align="center" sortable prop="urls" label="封面图" width="120px">
                <template slot-scope="scope">
                    <el-image v-if="scope.row.urls" style="width: 90px;" :src="scope.row.urls"
                        :preview-src-list="[scope.row.urls]" />
                    <div v-if="scope.row.urls == null">没有图片</div>
                </template>
            </el-table-column>
            <el-table-column align="center" sortable prop="image" label="作品" width="220px">
                <template slot-scope="scope">
                    <template v-if="scope.row.type === 1">
                        <video :src="scope.row.image" style="width: 80px;" v-if="scope.row.image" controls>
                            Your browser does not support the video tag.
                        </video>
                        <div v-if="scope.row.image == null">没有视频</div>
                    </template>
                    <template v-else>
                        <el-image v-for="(image, index) in scope.row.image.split(',')" :key="index" :src="image"
                            style="margin-right: 5px; width: 90px;" :preview-src-list="[image]"></el-image>
                        <div v-if="scope.row.image == null">没有图片</div>
                    </template>
                </template>
            </el-table-column>
            <el-table-column align="center" sortable prop="createTime" label="创建时间" width="160">
                <template slot-scope="scope">
                    <div>{{ transformDate(scope.row.createTime) }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" sortable prop="updateTime" label="更新时间" width="160">
                <template slot-scope="scope">
                    <div>{{ transformDate(scope.row.updateTime) }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" show-overflow-tooltip width="300px" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="IsZhiD(scope.row)">是否置顶</el-button>
                    <el-button v-if="scope.row.state === 1 || scope.row.state === 2" size="mini" type="info"
                        disabled>已审核</el-button>
                    <el-button v-else size="mini" type="primary" @click="upShenhe(scope.row)">审核作品</el-button>
                    <el-button size="mini" type="danger" @click="delShenHe(scope.row)">删除作品</el-button>

                </template>
            </el-table-column>
        </el-table>

        <!-- 是否置顶 -->
        <el-dialog title="处理置顶界面" :visible.sync="editFormUpZhiding" width="20%">
            <el-radio v-model="radio" label="1">置顶</el-radio>
            <el-radio v-model="radio" label="0">取消置顶</el-radio>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeUpZhiD()'>取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="UpZhiD()"
                    v-if="radio == '1'">置顶</el-button>
                <el-button size="small" type="danger" :loading="loading" @click="UpZhiD()"
                    v-if="radio == '0'">取消置顶</el-button>
            </div>
        </el-dialog>

        <!-- 审核提现-->
        <el-dialog title="审核作品界面" :visible.sync="editFormUpShenhe" width="30%">
            <el-form label-width="80px">
                <el-form-item label="审核状态">
                    <el-select v-model="statuss" placeholder="请选择审核状态">
                        <el-option v-for="item in options3" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="驳回原因" v-if="statuss === 2">
                    <el-input size="small" v-model="backRemark" auto-complete="off" placeholder="请输入驳回原因 "></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeUpShenhe()'>取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="upShenheZuopin()">确定</el-button>
            </div>
        </el-dialog>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>

<script>
import { getPublishList } from "../../api/userMG"
import { aduitAccessPublish } from "../../api/userMG"
import { aduitNoAccessPublish, setSort, dePublishByAdmin } from "../../api/userMG"
import Pagination from '../../components/Pagination'
export default {
    data() {
        return {
            workData: [],
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 20,
                total: 10
            },
            keyword: '',
            userName: '',
            loading: false,
            editFormUpZhiding: false,
            radio: '1',
            editFormUpShenhe: false,
            status: -1,
            backRemark: '',
            type: -1,
            statuss: '',
            options: [
                {
                    value: -1,
                    label: '全部'
                },
                {
                    value: 0,
                    label: '待审核'
                },
                {
                    value: 1,
                    label: '审核成功'
                }, {
                    value: 2,
                    label: '审核不通过'
                }],
            options1: [
                {
                    value: -1,
                    label: '全部'
                },
                {
                    value: 0,
                    label: '文章'
                }, {
                    value: 1,
                    label: '视频'
                }],
            options3: [
                {
                    value: 1,
                    label: '审核成功'
                }, {
                    value: 2,
                    label: '审核不通过'
                }],
        }
    },
    // 注册组件
    components: {
        Pagination
    },
    created() {
        this.getWork(1);
    },

    methods: {
        delShenHe(row) {
            console.log('delShenHe============')
            // this.loading = true
            this.$confirm('确定要删除该作品吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                dePublishByAdmin({ id: row.id })
                    .then(res => {
                        if (res.code == 200) {
                            this.getWork(1)
                        } else {
                            this.$message({
                                type: 'info',
                                message: res.msg
                            })
                        }
                    })
                    .catch(err => {
                        // this.loading = false
                    })
            })
                .catch(() => {

                })
        },
        // 修改审核状态
        upShenheZuopin() {
            if (this.statuss === 1) {
                let data = {
                    id: this.id,
                    state: this.statuss,
                    backRemark: 0
                }
                aduitAccessPublish(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.editFormUpShenhe = false
                        this.getWork(1)
                    } else {
                        this.$message.error(res.msg)
                        this.editFormUpShenhe = false
                    }
                })
            } else if (this.statuss === 2) {
                let data = {
                    id: this.id,
                    state: this.statuss,
                    backRemark: this.backRemark
                }
                aduitNoAccessPublish(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.editFormUpShenhe = false
                        this.getWork(1)
                    } else {
                        this.$message.error(res.msg)
                        this.editFormUpShenhe = false
                    }
                })
            }

        },
        // 关闭审核编辑页
        closeUpShenhe() {
            this.editFormUpShenhe = false
            this.status = ''
            this.backRemark = ''
            this.$message({
                type: 'info',
                message: '已取消修改'
            })
        },
        // 打开审核编辑页
        upShenhe(row) {
            this.editFormUpShenhe = true;
            this.id = row.id;
        },
        // 处理置顶
        UpZhiD() {
            if (this.radio === '1') {
                setSort({
                    id: this.id,
                    sort: 0
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.editFormUpZhiding = false
                        this.getWork(1)
                    } else {
                        this.$message.error(res.msg)
                        this.editFormUpZhiding = false
                    }
                })
            } else if (this.radio === '0') {
                setSort({
                    id: this.id,
                    sort: 1000
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.editFormUpZhiding = false
                        this.getWork(1)
                    } else {
                        this.$message.error(res.msg)
                        this.editFormUpZhiding = false
                    }
                })
            }
        },
        // 关闭修改对话框
        closeUpZhiD() {
            this.editFormUpZhiding = false
            this.$message({
                type: 'info',
                message: '已取消修改'
            })
        },
        // 打开修改置顶编辑页
        IsZhiD(row) {
            this.editFormUpZhiding = true;
            this.id = row.id;
        },
        // 分页插件事件
        callFather(parm) {
            this.pageparm.page = parm.currentPage
            this.getWork(parm.currentPage)
        },
        // 搜索
        search() {
            this.getWork(1);
        },
        // 重置数据
        chongzhi() {
            this.keyword = '';
            this.userName = '';
            this.type = -1;
            this.status = -1;
            this.getWork(1);
        },
        // 审核不通过
        updateNo(row) {
            this.$prompt("请输入不通过/驳回的原因", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^(?!(\s+$))/,
                inputErrorMessage: '不可以空数据提交!'
            }).then(({ value }) => {
                let data = {
                    id: row.id,
                    state: 2,
                    backRemark: value
                }
                aduitNoAccessPublish(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.getWork(1)
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }).catch((err) => {
                this.$message({
                    type: "info",
                    message: "已取消不通过",
                });
            });
        },

        // 审核通过
        updateYes(row) {
            console.log('row', row)
            this.$confirm("确定通过吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "success",
            }).then(() => {
                let data = {
                    id: row.id,
                    state: 1,
                    backRemark: 0
                }
                aduitAccessPublish(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.getWork(1)
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }).catch((err) => {
                this.$message({
                    type: "info",
                    message: "已取消通过",
                });
            });
        },

        // 审核状态
        zhuangTai: function (row) {
            if (row.state == 0) {
                return "待审核"
            } else if (row.state == 1) {
                return "审核通过"
            } else if (row.state == 2) {
                return "审核不通过"
            }
        },

        // 类型态
        Type: function (row) {
            if (row.type == 0) {
                return "文章"
            } else if (row.type == 1) {
                return "视频"
            }
        },

        // 获取作品列表
        getWork(page) {
            this.loading = true;
            let data = {
                userName: this.userName,
                title: this.keyword,
                type: this.type,
                page: (page - 1) * 20,
                status: this.status,
            }
            getPublishList(data).then((res) => {
                this.loading = false;
                if (res.code != 200) {
                    this.$Message({
                        type: "info",
                        message: res.msg,
                    });
                } else {
                    this.workData = res.data.list;
                    this.pageparm.currentPage = page;
                    this.pageparm.total = res.data.count;
                    return;
                }
            })
        }
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/works/Works.vue